import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { OrderBuilder } from '../components/OrderBuilder/OrderBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { DoorsSection } from '../components/DoorsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TrustSection } from '../components/TrustSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UrgencySection } from '../components/UrgencySection';
import { DistributorSection } from '../components/DistributorSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-341" data-mp="m7lg12w3ih8y">
      <SiteHeader data-id="element-342" data-mp="m83jajh6dvqd" />
      <main data-id="element-343" data-mp="m5hc4ky75i8o">
        <Hero data-id="element-344" data-mp="m58wilaovyts" />
        <OrderBuilder data-id="element-345" data-mp="29s92kf0fqyp" />
        <ProblemSection data-id="element-346" data-mp="2aa9zucmatcy" />
        <DoorsSection data-id="element-347" data-mp="2blejwdw0554" />
        <BenefitsSection data-id="element-348" data-mp="27ntv6bnv5j4" />
        <TestimonialsSection data-id="element-349" data-mp="3tglanpdpts3r" />
        <TrustSection data-id="element-350" data-mp="3tfjvp9tkwlgr" />
        <UrgencySection data-id="element-351" data-mp="3tf0drt3xhx2q" />
        <DistributorSection data-id="element-352" data-mp="3peq8kinynaox" />
        <FaqSection data-id="element-353" data-mp="3pdyc75mjh8xl" />
        <FinalCta data-id="element-354" data-mp="3pfj6qv8usrvg" />
      </main>
      <SiteFooter data-id="element-355" data-mp="3pguc2zhy67oo" />
      <FloatingWhatsApp data-id="element-356" data-mp="3kfwsqjl7b7ll" />
    </div>;
}